/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { Int32ListSearch } from './Int32ListSearch';
import {
    Int32ListSearchFromJSON,
    Int32ListSearchFromJSONTyped,
    Int32ListSearchToJSON,
} from './Int32ListSearch';
import type { Int32NullableListSearch } from './Int32NullableListSearch';
import {
    Int32NullableListSearchFromJSON,
    Int32NullableListSearchFromJSONTyped,
    Int32NullableListSearchToJSON,
} from './Int32NullableListSearch';
import type { StringListSearch } from './StringListSearch';
import {
    StringListSearchFromJSON,
    StringListSearchFromJSONTyped,
    StringListSearchToJSON,
} from './StringListSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface DashboardPratiqueProSearch
 */
export interface DashboardPratiqueProSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof DashboardPratiqueProSearch
     */
    codeContrat?: TextSearch;
    /**
     * 
     * @type {Int32ListSearch}
     * @memberof DashboardPratiqueProSearch
     */
    idtypeContrat?: Int32ListSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof DashboardPratiqueProSearch
     */
    referent?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof DashboardPratiqueProSearch
     */
    apprenant?: TextSearch;
    /**
     * 
     * @type {Int32NullableListSearch}
     * @memberof DashboardPratiqueProSearch
     */
    idcentre?: Int32NullableListSearch;
    /**
     * 
     * @type {Int32NullableListSearch}
     * @memberof DashboardPratiqueProSearch
     */
    idmetier?: Int32NullableListSearch;
    /**
     * 
     * @type {StringListSearch}
     * @memberof DashboardPratiqueProSearch
     */
    iddegre?: StringListSearch;
    /**
     * 
     * @type {StringListSearch}
     * @memberof DashboardPratiqueProSearch
     */
    statut?: StringListSearch;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardPratiqueProSearch
     */
    hideMasquees?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardPratiqueProSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof DashboardPratiqueProSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardPratiqueProSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardPratiqueProSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof DashboardPratiqueProSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardPratiqueProSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the DashboardPratiqueProSearch interface.
 */
export function instanceOfDashboardPratiqueProSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DashboardPratiqueProSearchFromJSON(json: any): DashboardPratiqueProSearch {
    return DashboardPratiqueProSearchFromJSONTyped(json, false);
}

export function DashboardPratiqueProSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardPratiqueProSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'codeContrat': !exists(json, 'codeContrat') ? undefined : TextSearchFromJSON(json['codeContrat']),
        'idtypeContrat': !exists(json, 'idtypeContrat') ? undefined : Int32ListSearchFromJSON(json['idtypeContrat']),
        'referent': !exists(json, 'referent') ? undefined : TextSearchFromJSON(json['referent']),
        'apprenant': !exists(json, 'apprenant') ? undefined : TextSearchFromJSON(json['apprenant']),
        'idcentre': !exists(json, 'idcentre') ? undefined : Int32NullableListSearchFromJSON(json['idcentre']),
        'idmetier': !exists(json, 'idmetier') ? undefined : Int32NullableListSearchFromJSON(json['idmetier']),
        'iddegre': !exists(json, 'iddegre') ? undefined : StringListSearchFromJSON(json['iddegre']),
        'statut': !exists(json, 'statut') ? undefined : StringListSearchFromJSON(json['statut']),
        'hideMasquees': !exists(json, 'hideMasquees') ? undefined : json['hideMasquees'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function DashboardPratiqueProSearchToJSON(value?: DashboardPratiqueProSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'codeContrat': TextSearchToJSON(value.codeContrat),
        'idtypeContrat': Int32ListSearchToJSON(value.idtypeContrat),
        'referent': TextSearchToJSON(value.referent),
        'apprenant': TextSearchToJSON(value.apprenant),
        'idcentre': Int32NullableListSearchToJSON(value.idcentre),
        'idmetier': Int32NullableListSearchToJSON(value.idmetier),
        'iddegre': StringListSearchToJSON(value.iddegre),
        'statut': StringListSearchToJSON(value.statut),
        'hideMasquees': value.hideMasquees,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

